<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	export default {
		name: 'App',
		components: {}
	};
</script>

<style lang="less">
	@font-face {
		font-family: 'AvenirHeavy';
		src: url('./font/AvenirHeavy.ttf');
	}
	.fAvenirH {
	    font-family: AvenirHeavy;
	}

	html {
		font-size: 12px;
	}

	body {
		padding-right: 0px !important;
		overflow: hidden;
	}

	#app {
		font-family: PingFangSC-Regular, PingFang SC;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		/* color: #2c3e50; */
		/* margin-top: 60px; */
	}

	.center-box {
		width: 1200px;
		margin: auto;
	}

	.loadingBigWrap {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		overflow: hidden;
		background-color: rgba(0, 0, 0, 0.4);
		box-sizing: border-box;

		.loadingWrap {
			position: fixed;
			top: ~'calc(50% - 90px)';
			left: ~'calc(50% - 35px)';
			z-index: 100000;
			width: 100px;
			height: 100px;
			background: rgba(0, 0, 0, 0);
			border-radius: 20px;
		}

		.loading {
			width: 70px;
			height: 40px;
			margin: 25px 0 0 2px;
		}

		.loading>div {
			width: 20px;
			height: 20px;
			background-color: #0f6eea;
			border-radius: 100%;
			display: inline-block;
			-webkit-animation: bouncedelay 1.4s infinite ease-in-out;
			animation: bouncedelay 1.4s infinite ease-in-out;
			-webkit-animation-fill-mode: both;
			animation-fill-mode: both;
		}

		.loading .bounce1 {
			-webkit-animation-delay: -0.32s;
			animation-delay: -0.32s;
		}

		.loading .bounce2 {
			-webkit-animation-delay: -0.16s;
			animation-delay: -0.16s;
		}
	}

	@-webkit-keyframes bouncedelay {

		0%,
		80%,
		100% {
			-webkit-transform: scale(0);
		}

		40% {
			-webkit-transform: scale(1);
		}
	}

	@keyframes bouncedelay {

		0%,
		80%,
		100% {
			transform: scale(0);
			-webkit-transform: scale(0);
		}

		40% {
			transform: scale(1);
			-webkit-transform: scale(1);
		}
	}

	// 门店资质
	.flex-component {
		color: #222222;
		background-color: #ffffff;
		border: 1px solid #e8e8e8;
		padding: 20px;
		margin-bottom: 20px;

		.flex-title {
			border-bottom: 1px solid #e8e8e8;
			display: flex;
			padding-bottom: 20px;
			margin-bottom: 20px;

			label {
				font-size: 14px;
				font-weight: bold;
				position: relative;
				padding-left: 10px;
			}

			label:after {
				position: absolute;
				left: 0;
				top: 3px;
				background-color: #0f6eea;
				width: 3px;
				height: 15px;
				content: '';
			}

			p {
				font-size: 16px;
				margin-bottom: 0;
			}
		}

		.flex-cont {
			text-align: left;
			font-size: 12px;

			label {
				font-weight: bold;
				padding-bottom: 6px;
				display: block;
			}

			p {
				color: #444444;
				margin: 0;
			}
		}

		.flex-prompt {
			text-align: left;
			font-weight: bold;
			font-size: 14px;
			padding-left: 10px;
			position: relative;
			margin-bottom: 15px;
		}

		.flex-prompt:after {
			content: '*';
			color: #F56C6C;
			position: absolute;
			left: -1px;
			top: 0;
		}

		.last {
			margin: 0 0 8px 0 !important;
		}
	}
</style>
